<template>
  <span>
    Unsere Mission ist es, Unternehmen dabei zu helfen, ihre <strong>Geschäftsprozesse
    zu digitalisieren</strong> und so ihre Effizienz und Wettbewerbsfähigkeit zu
    steigern. Dabei setzen wir auf ein <strong>Team hochqualifizierter
    Software-Engineers, Business Analysts, Product Owner und Scrum-Master</strong>, die
    gemeinsam mit unseren Kunden <strong>maßgeschneiderte Lösungen</strong> entwickeln und
    umsetzen. Wir streben danach, die Erwartungen unserer Kunden nicht nur zu
    erfüllen, sondern zu übertreffen, indem wir ihnen innovative,
    zukunftsweisende und auf ihre spezifischen Bedürfnisse <strong>zugeschnittene
    Technologielösungen</strong> anbieten. Unser Ziel ist es, unsere Kunden auf ihrem Weg
    in die digitale Transformation zu begleiten und ihnen dabei zu helfen, ihr
    volles <strong>Potenzial auszuschöpfen</strong>.
  </span>
</template>